import { flip, prop, curry, compose, equals } from 'ramda';
import parseCode from './parseCode.js';
import validateCode from './validateCode.js';
import { Turn } from '../presets/rules.js';

var _prop=flip(prop);function detectTurn(r,e){if(!validateCode(e))throw new TypeError("invalid arguments");return compose(equals(r),_prop(Turn),parseCode.prop("side"))(e)}var detectTurn$1 = curry(detectTurn);

export { detectTurn$1 as default };
//# sourceMappingURL=detectTurn.js.map
